module.exports = __webpack_public_path__ + "static/logo-b2a1d56faf14261c72a16b41ca7be5c0.png";